import { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { faUserCircle } from '@fortawesome/pro-light-svg-icons'
import { Icon, Button, Select, Tooltip } from '@nazka/nazka.mapframe.components'
import { useNavigate } from 'react-router-dom'

import { useAuth } from '@App/components/AuthProvider/AuthProvider'
import { logoutUser } from '@services/auth.service'
import { setActiveProject } from '@App/pages/MissionSetup/mission-setup.slice'
import { RESET_STATE } from '@App/app.store'
import theme from '@css/theme.style.json'

import './appbar.styl'

function Appbar({ projects }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { user } = useAuth()
  const accountRef = useRef()
  const [projectOptions, setProjectOptions] = useState([])

  const activeProject = useSelector(state => state.missionSetup.activeProject)

  useEffect(() => {
    if (projects) {
      setProjectOptions(projects.map(project => ({
        id: project.id,
        label: project.id,
      })))
    }
  }, [projects])

  return (
    <div className="appbar">
      <div className="appbar__icon">
        <Icon icon="/img/icons/nav/mosquito.svg" />
      </div>
      <div className="appbar__content">
        <span>Mobvec</span>
        <span>/</span>
        <span className="appbar__content__select">
          <div className="appbar__content__select__selector">
            <Select
              onInputChange={(project) => {
                dispatch({ type: RESET_STATE })
                dispatch(setActiveProject(projects.find(p => p.id === project.id)))
              }}
              placeholder="select..."
              options={projectOptions}
              value={projectOptions.find(project => project.id === activeProject?.id) || null}
              className="appbar__content__select__selector__select"
              width="200px"
              menuStyle={{ zIndex: 99999, marginTop: '12px' }}
              css={{ border: 'none', button: { padding: 'initial', width: 'fit-content', fontSize: '18px' }, span: { display: 'flex', alignItems: 'center', gap: '10px' } }}
            />
          </div>
        </span>
      </div>
      <div className="appbar__actions">
        <Tooltip
          id="user-modal"
          openOnClick
          clickable
          border={`solid 1px ${theme.color.common.grey.xlight}`}
          opacity={1}
          tooltip={(
            <div className="appbar__actions__action__login-menu">
              <p className="appbar__actions__action__login-menu__email">
                {user.email}
              </p>
              <Button
                className="appbar__actions__action__login-menu__logout"
                onClick={() => {
                  logoutUser()
                  navigate('/login')
                }}
              >
                Logout
              </Button>
            </div>
          )}
        >
          <Button
            icon={faUserCircle}
            iconSize="30px"
            className="appbar__actions__action"
            layout="ghost"
            hover={false}
            ref={accountRef}
            rootElProps={{ 'data-tooltip-id': 'user-modal' }}
          />
        </Tooltip>
      </div>
    </div>
  )
}

export default Appbar
